import { OnBoardingModel } from "@/model/onBoarding/onBoarding";
import { SettingDetailModel } from "@/model/setting/settingDetailModel";

export function ConvertToSettingDetail(settingDetail: any) {
  const settingDetailModel: SettingDetailModel = {
    id: settingDetail.id,
    merchantId: settingDetail.merchantId,
    isRegisteredSSO: settingDetail.isRegisteredSSO,
    registeredSSONumber: settingDetail.registeredSSONumber,
    isHeadOffice: settingDetail.isHeadOffice,
    branchNumber: settingDetail.branchNumber,
    socialSecurityFundContributionRate: settingDetail.socialSecurityFundContributionRate,
    employerContritutionMaxTotal: settingDetail.employerContritutionMaxTotal,
    socialSecurityFundContributionMaxTotal: settingDetail.socialSecurityFundContributionMaxTotal,
    employerContritutionRate: settingDetail.employerContritutionRate,
    bankAccountId: settingDetail.bankAccountId,
    paymentDefaultDay: settingDetail.paymentDefaultDay,
    employeeWelfareFundParticipation: settingDetail.employeeWelfareFundParticipation,
    employeeWelfareFundEmployeeRate: settingDetail.employeeWelfareFundEmployeeRate,
    employeeWelfareFundEmployerRate: settingDetail.employeeWelfareFundEmployerRate,
  };

  return settingDetailModel;
}
export function ConvertToOnBoarding(onBoardingRaw: any): OnBoardingModel {
  const onBoarding: OnBoardingModel = {
    isHide: onBoardingRaw.isHide,
    isViewDepartment: onBoardingRaw.isViewDepartment,
    isViewEmployee: onBoardingRaw.isViewEmployee,
    isViewPayrun: onBoardingRaw.isViewPayrun,
    isViewRevenueDeduct: onBoardingRaw.isViewRevenueDeduct,
    isViewSetting: onBoardingRaw.isViewSetting,
  };
  return onBoarding;
}
